import React, {useContext} from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { startCase } from "lodash";
import helpers from "utils/helpers";
import AuthContext from '../../../context/AuthContext'

const ListingView = ({ setEmployeeView, currentItem }) => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext)
  const getShortId = (name, id) =>
  `${name?.slice(0, 3) ?? ''}${id?.slice(-3) ?? ''}`

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <form className="sm:py-4 sm:px-2 py-8 px-7">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[940px] max-h-[85vh] overflow-y-auto	">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">{t("O_VIEW_USER")}</h3>
                <button className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none" onClick={() => setEmployeeView(false)}>
                  <span className=" text-[#B8BBBF]  text-4xl " title="Close">
                    ×
                  </span>
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <h3 className="text-xl font-semibold">Employee details</h3>
                <div className="grid grid-cols-3">
                  {currentItem?.Employee?.employeeId ? <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Employee ID</strong>
                      <h6>{currentItem?.employmentStatus === "terminated" ? getShortId(user?.name, currentItem?.Employee?._id): currentItem?.Employee?.employeeId || ""}</h6>
                    </div>
                  </div> : null}
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Employee name</strong>
                      <h6>{currentItem?.Employee?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Email ID</strong>
                      <h6>{currentItem?.Employee?.email || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-6 w-full group">
                      <strong>Year of experience</strong>
                      <h6>{currentItem?.yearOfExperiece || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>DOB</strong>
                      <h6>{dayjs(currentItem?.Employee?.dob).format("MM-DD-YYYY")} </h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Country</strong>
                      <h6>{currentItem?.EmployeeCountry?.name} </h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>State</strong>
                      <h6>{currentItem?.EmployeeState?.name} </h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>City</strong>
                      <h6>{currentItem?.Employee.city|| ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-6 w-full group">
                      <strong>Skills</strong>
                      <h6>{currentItem?.EmployeeSkills?.map((skill) => skill?.name).join(", ")}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Job applied date</strong>
                      <h6>{dayjs(currentItem?.createdAt).format("MM-DD-YYYY hh:mm A")} </h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>LinkedIn</strong>
                      <h6>{currentItem.Employee?.linkedInLink ? (
                        <a href={currentItem.Employee.linkedInLink} target="_blank" rel="noopener noreferrer">
                          View Profile
                        </a>
                      ) : (
                        <span>LinkedIn profile not added</span>
                      )}</h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="px-6">
                {" "}
                <hr />
              </div>
              <div className="relative p-6 flex-auto">
                <h3 className="text-xl font-semibold">Job details</h3>
                <div className="grid grid-cols-3">
                  <div className="sm:py-4 sm:px-2 py-8 px-7 ">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Job Title</strong>
                      <h6>{currentItem?.Job?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Country</strong>
                      <h6>{currentItem?.JobCountry?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>State</strong>
                      <h6>{currentItem?.JobState?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>City</strong>
                      <h6>{currentItem?.Job.city || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Category</strong>
                      <h6>{currentItem?.JobCategory?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Subcategory</strong>
                      <h6>{currentItem?.JobSubCategory?.name}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Job created date</strong>
                      <h6>{dayjs(currentItem?.Job?.createdAt).format("MM-DD-YYYY hh:mm A")} </h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Duration type</strong>
                      <h6>{currentItem?.duration} </h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Department</strong>
                      <h6>{currentItem?.JobDepartment?.name} </h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Employment length (In days)</strong>
                      <h6>{currentItem?.Job?.employmentLength}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Skills</strong>
                      <h6>{currentItem?.JobSkills?.map((jobSkill) => jobSkill?.name).join(", ")}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Status</strong>
                      <h6>{startCase(currentItem?.employmentStatus === "terminated"? "Terminated" :currentItem?.formStatus)}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      {currentItem?.status === "accepted" ? (
                        <>
                          <strong>Accepted</strong>
                          <h6>{dayjs(currentItem?.acceptedRejectedAt).format("MM-DD-YYYY hh:mm A")} </h6>
                        </>
                      ) : (
                        <>
                          <strong>Rejected</strong>
                          <h6>{helpers.ternaryCondition(currentItem?.updatedAt, dayjs(currentItem?.updatedAt).format("MM-DD-YYYY hh:mm A"), "N/A")} </h6>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="gird">
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Job description</strong>
                      <div className="inner-html" dangerouslySetInnerHTML={{ __html: currentItem?.Job?.description }} />
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Termination condition</strong>
                      <div className="inner-html" dangerouslySetInnerHTML={{ __html: currentItem?.Job?.terminationCondition }} />
                    </div>
                  </div>
                  {currentItem?.status === "rejected" ? (
                    <div className="sm:py-4 sm:px-2 py-8 px-7">
                      <div className="relative z-0 mb-2 w-full group">
                        <strong>Reason</strong>
                        <h6>{currentItem.rejectionReason}</h6>
                      </div>
                    </div>
                  ) : currentItem.AssignedForms?.length >= 1 ? (
                    <div className="sm:py-4 sm:px-2 py-8 px-7">
                      <div className="relative z-0 mb-2 w-full group">
                        <strong>Assigned forms</strong>
                        <h6>
                          {currentItem.AssignedForms
                            .map((item) => item?.formName)
                            .join(", ")}
                        </h6>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                <button className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150" type="button" onClick={() => setEmployeeView(false)}>
                  {t("O_BACK")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default ListingView;
